import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from '@getro/rombo';
import { Flex, Box, Text } from 'rebass/styled-components';
import { ChevronRight } from 'lucide-react';
import { SparkleIcon } from './SparkleIcon';

export const PeopleFinderCell = ({ job, onFindCandidates, onOpenProject }) => {
  const hasProject = Boolean(job.findemProjectId);

  if (hasProject) {
    return (
      <Tooltip
        content="View and manage candidates for this role in People Finder."
        position="top-start"
        openWith={['hover']}
        trigger={
          <Flex
            alignItems="center"
            sx={{ gap: '4px', cursor: 'pointer', color: 'text.main' }}
            onClick={() => onOpenProject(job)}
          >
            <Text fontSize="14px" fontWeight="500" sx={{ textDecoration: 'underline' }}>
              Open project
            </Text>
            <Box as={ChevronRight} size="16px" sx={{ flexShrink: 0 }} />
          </Flex>
        }
      />
    );
  }

  return (
    <Tooltip
      content="Find and prioritize top candidates, both inside and outside your network, in a new People Finder project."
      position="top-start"
      openWith={['hover']}
      trigger={
        <Flex
          alignItems="center"
          sx={{ gap: '4px', cursor: 'pointer', color: 'text.main' }}
          onClick={() => onFindCandidates(job)}
        >
          <Box width="16px" height="16px" sx={{ flexShrink: 0 }}>
            <SparkleIcon />
          </Box>
          <Text fontSize="14px" fontWeight="500" sx={{ textDecoration: 'underline' }}>
            Find candidates
          </Text>
        </Flex>
      }
    />
  );
};

PeopleFinderCell.propTypes = {
  job: PropTypes.object.isRequired,
  onFindCandidates: PropTypes.func.isRequired,
  onOpenProject: PropTypes.func.isRequired,
};
